import { useQuery } from 'react-query';

import { getStats, getDashboardStats } from '../Services/Api';

const useStatsQuery = (
  key: any,
  {
    postId,
    newsletterId,
    statsSlug,
    from,
    to,
    dashboard = false,
    interval,
    dimensionId,
    scope,
  }: any,
  useQueryProps?: any,
) => {
  const { data, ...params } = useQuery(
    [key, postId, statsSlug, from, to, interval, dimensionId].filter((n) => n),
    () => {
      if (dashboard) {
        return getDashboardStats(
          postId,
          newsletterId,
          statsSlug,
          from,
          to,
          interval,
          dimensionId,
          scope,
        );
      }

      return getStats(postId, statsSlug, from, to, interval);
    },
    {
      refetchOnWindowFocus: false,
      ...useQueryProps,
    },
  );

  return {
    data: data?.data || [],
    ...params,
  };
};

export default useStatsQuery;
